const loggerDebug = (message: string): void => {
  console.log(`Debug: ${message}`)
}

const loggerInfo = (message: string): void => {
  console.log(`Info: ${message}`)
}

const loggerWarn = (message: string): void => {
  console.log(`Warning: ${message}`)
}

const loggerError = (message: string): void => {
  console.log(`Error: ${message}`)
}

// eslint-disable-next-line import/prefer-default-export
export const logger = {
  debug: loggerDebug,
  info: loggerInfo,
  warn: loggerWarn,
  error: loggerError,
}
